<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>

  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="heading mb-0">Leases Report</h5>
          <div class="d-flex gap-2 align-items-center" *ngIf="checkDownloadPermission && activeTab === 'leases'">
            <button class="btn btn-outline-danger btn-sm" (click)="downloadReport('pdf')" [disabled]="isDownloading">
              <span *ngIf="isDownloading && activeDownloadType === 'pdf'" class="spinner-border spinner-border-sm me-1"></span>
              <i class="bi bi-file-earmark-pdf me-1" *ngIf="!isDownloading || activeDownloadType !== 'pdf'"></i>PDF
            </button>
            <button class="btn btn-outline-success btn-sm" (click)="downloadReport('csv')" [disabled]="isDownloading">
              <span *ngIf="isDownloading && activeDownloadType === 'csv'" class="spinner-border spinner-border-sm me-1"></span>
              <i class="bi bi-file-earmark-spreadsheet me-1" *ngIf="!isDownloading || activeDownloadType !== 'csv'"></i>CSV
            </button>
            <button class="btn btn-outline-primary btn-sm" (click)="openShareModal('email')" [disabled]="isDownloading">
              <i class="bi bi-envelope me-1"></i> Email
            </button>
            <button class="btn btn-outline-success btn-sm" (click)="openShareModal('whatsapp')" [disabled]="isDownloading">
              <i class="bi bi-whatsapp me-1"></i> WhatsApp
            </button>
            <span *ngIf="isDownloading" class="text-muted small ms-2">{{ downloadProgress }}</span>
          </div>
        </div>

        <!-- Tabs -->
        <ul class="nav nav-tabs mb-3">
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'leases'" (click)="setTab('leases')" role="button">Leases</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'managers'" (click)="setTab('managers')" role="button">By Property Manager</a>
          </li>
        </ul>

        <!-- Leases tab -->
        <div *ngIf="activeTab === 'leases'">
        <!-- Filters -->
        <form [formGroup]="filterForm">
          <div class="row g-2 mb-3">
            <div class="col-md-3 col-sm-6">
              <label class="form-label">Managed By</label>
              <ng-select formControlName="managed_by" [items]="managersItems" bindLabel="label" bindValue="value"
                placeholder="All Managers" [multiple]="true" [closeOnSelect]="false" [virtualScroll]="true"
                (scrollToEnd)="onManagerScrollEnd()" (search)="searchManager$.next($event.term)"
                (change)="onFilterChange()" (clear)="onFilterChange()" class="select2-sm">
              </ng-select>
            </div>
            <div class="col-md-3 col-sm-6">
              <label class="form-label">Lease End From</label>
              <input type="date" class="form-control form-control-sm" formControlName="lease_end_start" (change)="onFilterChange()">
            </div>
            <div class="col-md-3 col-sm-6">
              <label class="form-label">Lease End To</label>
              <input type="date" class="form-control form-control-sm" formControlName="lease_end_end"
                [min]="filterForm.get('lease_end_start')?.value" (change)="onFilterChange()">
            </div>
            <div class="col-md-3 col-sm-6 d-flex align-items-end">
              <button class="btn btn-outline-secondary btn-sm w-100" (click)="resetFilters()" [disabled]="!disableClear">Clear</button>
            </div>
          </div>
        </form>

        <!-- Summary Cards -->
        <div class="d-flex flex-wrap gap-2 mb-3" *ngIf="summaryData">
          <div class="summary-card bg-primary text-white">
            <div class="summary-value">{{ summaryData.total_leases }}</div>
            <div class="summary-label">Total Leases</div>
          </div>
          <div class="summary-card bg-warning text-dark" style="cursor: pointer;"
            title="Click to filter leases expiring within 30 days"
            (click)="applyExpiringFilter(30)">
            <div class="summary-value">{{ summaryData.expiring_within_30_days }}</div>
            <div class="summary-label">Expiring in 30 Days <i class="bi bi-funnel-fill ms-1" style="font-size:0.7rem"></i></div>
          </div>
          <div class="summary-card bg-danger text-white" style="cursor: pointer;"
            title="Click to filter leases expiring within 60 days"
            (click)="applyExpiringFilter(60)">
            <div class="summary-value">{{ summaryData.expiring_within_60_days }}</div>
            <div class="summary-label">Expiring in 60 Days <i class="bi bi-funnel-fill ms-1" style="font-size:0.7rem"></i></div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive">
          <table class="table table-hover table-sm mt-2">
            <thead>
              <tr>
                <th>Property</th>
                <th>Tenant</th>
                <th>Lease Amount</th>
                <th>Security Deposit</th>
                <th>Start Date</th>
                <th>End Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of reportData">
                <td>{{ row.property_name || '-' }}</td>
                <td>{{ row.tenant_name || '-' }}</td>
                <td>{{ row.lease_amount != null ? (row.lease_amount | currency:'INR':'symbol':'1.0-0') : '-' }}</td>
                <td>{{ row.security_deposit != null ? (row.security_deposit | currency:'INR':'symbol':'1.0-0') : '-' }}</td>
                <td>{{ row.start_date ? (row.start_date | date:'dd/MM/yyyy') : '-' }}</td>
                <td>{{ row.end_date ? (row.end_date | date:'dd/MM/yyyy') : '-' }}</td>
              </tr>
              <tr *ngIf="reportData.length === 0">
                <td colspan="6" class="text-center text-muted py-3">No leases found</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="dataTables_paginate" *ngIf="pageCount > 1">
          <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
        </div>
        </div>

        <!-- By Property Manager tab -->
        <div *ngIf="activeTab === 'managers'">
          <div class="table-responsive">
            <table class="table table-hover table-sm mt-2">
              <thead>
                <tr>
                  <th>Property Manager</th>
                  <th>Total Leases</th>
                  <th title="Expired leases on properties whose listing status is Rent Occupied">Expired Leases</th>
                  <th title="Rent Occupied properties with no active lease">Without Leases</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of managerReportData">
                  <td>{{ row.manager_name || '-' }}</td>
                  <td>{{ row.total_leases }}</td>
                  <td>
                    <span class="badge" [ngClass]="row.expired_leases > 0 ? 'badge-danger' : 'badge-secondary'">
                      {{ row.expired_leases }}
                    </span>
                  </td>
                  <td>
                    <span class="badge" [ngClass]="row.without_leases > 0 ? 'badge-warning' : 'badge-secondary'">
                      {{ row.without_leases }}
                    </span>
                  </td>
                </tr>
                <tr *ngIf="managerReportData.length === 0">
                  <td colspan="4" class="text-center text-muted py-3">No data found</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Share Modal -->
  <div class="modal d-block" tabindex="-1" role="dialog" *ngIf="showShareModal" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Share Report via {{ shareType === 'email' ? 'Email' : 'WhatsApp' }}</h5>
          <button type="button" class="btn-close" (click)="closeShareModal()"></button>
        </div>
        <form [formGroup]="shareForm">
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Search User</label>
              <ng-select formControlName="selectedUser" [items]="managersItems" bindLabel="label" bindValue="value"
                placeholder="Search by name..." (search)="searchManager$.next($event.term)"
                (change)="onShareUserChange($event)" class="select2-sm">
              </ng-select>
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <label class="form-label">First Name</label>
                <input type="text" class="form-control form-control-sm" formControlName="first_name" placeholder="First name">
              </div>
              <div class="col-6">
                <label class="form-label">Last Name</label>
                <input type="text" class="form-control form-control-sm" formControlName="last_name" placeholder="Last name">
              </div>
            </div>
            <div class="mb-3" *ngIf="shareType === 'email'">
              <label class="form-label">Email Address</label>
              <input type="email" class="form-control form-control-sm" formControlName="email" placeholder="Enter email">
            </div>
            <div class="mb-3" *ngIf="shareType === 'whatsapp'">
              <div class="row">
                <div class="col-4">
                  <label class="form-label">Code</label>
                  <input type="text" class="form-control form-control-sm" formControlName="country_code" placeholder="+91">
                </div>
                <div class="col-8">
                  <label class="form-label">WhatsApp Number</label>
                  <input type="text" class="form-control form-control-sm" formControlName="whatsapp" placeholder="Enter number">
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">File Type</label>
              <ng-select formControlName="file_type" [items]="reportTypeOptions" bindLabel="label" bindValue="value"
                [clearable]="false" class="select2-sm">
              </ng-select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" (click)="closeShareModal()">Cancel</button>
            <button type="button" class="btn btn-primary btn-sm" (click)="submitShare()">
              <i class="bi" [ngClass]="{'bi-envelope': shareType === 'email', 'bi-whatsapp': shareType === 'whatsapp'}"></i> Send
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
